
    import '/mnt/docs/guide/quickstart.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/guide/quickstart.md?type=demo')
};